

<app-bread-crumb 
    [Locations]="[{target : 'home', label : 'Home'}, {target : '/whatIsBeachwatch', label : 'About Beachwatch'}]"
    current="Content and data sources"
    RouteLocation="home" 
    Description="about Beachwatch">
</app-bread-crumb>


<div class="nsw-container">
    <div class="nsw-layout">
        <div class="nsw-layout__main">
            <div class="nsw-block">
                <h1>Content and data sources</h1> 
                <p>
                    Beachwatch reporting uses data collected from many sources. This data supports Beachwatch to provide information about how suitable a site is for swimming.
                </p>           
            </div> 
            
            <nav class="nsw-in-page-nav" aria-labelledby="in-page-nav">
                <div id="in-page-nav" class="nsw-in-page-nav__title">On this page</div>
                <ul>
                    <li>
                        <a routerLink="./" fragment="waterQualityDataPartners">Beachwatch partners</a>
                    </li>
                    <li>
                        <a routerLink="./" fragment="weatherRainfallTidesWarningsBOM">Bureau of Meteorology</a>
                    </li>
                    <li>
                        <a routerLink="./" fragment="rainfallSydneyWater">Sydney Water</a>
                    </li>
                    <li>
                        <a routerLink="./" fragment="lagoonDataMHL">Manly Hydraulics Laboratory</a>
                    </li>
                </ul>
            </nav> 

            <section class="nsw-section" id="waterQualityDataPartners">
                <div class="nsw-block">
                    <h2 id="waterQualityDataPartnersTitle">Beachwatch partners</h2>
                    <p> 
                        Our <app-external-link text="partners" link="/beachwatchPartners" [isExternalLink]="false"></app-external-link> collect water quality data including enterococci, conductivity, water temperature and swim site observations. 
                        This data is used to build models to generate water quality forecasts, to provide latest water quality results, and annual beach grades reported in the State of the Beaches reports.
                        <br/><br/>
                        The water quality data collected under the Beachwatch program can be view or downloaded. Results are usually updated within one week of sample collection.
                        <br/><br/>
                        <app-external-link text="Explore water quality data" link="/waterMonitoring/waterQualityData" [isExternalLink]="false"></app-external-link> 
                    </p>                   
                </div>               
            </section>
            
            <section class="nsw-section" id="weatherRainfallTidesWarningsBOM">
                <div class="nsw-block">
                    <h2 id="weatherRainfallTidesWarningsBOMTitle">Bureau of Meteorology</h2>
                    <p> 
                        Our water quality forecasts use Bureau of Meteorology (BoM) data to provide swimmers information on weather conditions, 
                        including weather forecast, maximum air temperature, ultra violet (UV) rating, chance of rainfall, expected amount of rainfall, 
                        wind direction and speed, swell height and direction, tides, marine wind, hazardous surf and tsunami warnings.
                        <br/><br/>
                        Rainfall data provided by BOM is used to generate daily water quality forecasts to provide real-time information on water quality. 
                        <br/><br/>
                        More information on <app-external-link text="BoM data" [link]="BOM_DATA_URL"></app-external-link>.                        
                    </p>                   
                </div>                
            </section>  
           
            <section class="nsw-section" id="rainfallSydneyWater">
                <div class="nsw-block">
                    <h2 id="rainfallSydneyWaterTitle">Sydney Water</h2>
                    <p> 
                        Rainfall data provided by Sydney Water is used to generate daily water quality forecasts in the Sydney and Illawarra regions to provide real-time information on water quality.                        
                    </p>                   
                </div>
            </section>  
            
            <section class="nsw-section" id="lagoonDataMHL">
                <div class="nsw-block">
                    <h2 id="lagoonDataMHLTitle">Manly Hydraulics Laboratory</h2>
                    <p> 
                        Lagoon status data (open and closed) provided by Manly Hydraulics Laboratory is considered in the forecasting of daily water quality for swim sites which may be impacted by lagoon outflow. 
                    </p> 
                    <p>Rainfall data provided by Manly Hydraulics Laboratory is used to generate daily water quality forecasts in the Central Coast and Hunter regions to provide real-time information on water quality.</p>
                    <!-- <ul>
                        <li>flow and water quality measurement and investigations</li>
                        <li>oceanographic, coastal, estuarine and riverine process studies</li>
                        <li>investigation and design of hydraulic, coastal and maritime structures.</li>
                    </ul> -->
                    <br/><br/>
                    More information about <app-external-link text="Manly Hydraulics Laboratory" [link]="MANLY_HYDRAULICS_LAB_URL"></app-external-link>
                </div>
            </section>
        </div>
    </div>
</div>
